import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  auditLogsHeartbeatStarted: false,
  auditLogsCompleteData: {
    event_id: "",
    widget_code: "coding_companion",
    action_performed: null,
    video_url: "video_url_na",
    payload: {
      seg_id: "segment_na",
      video_url: "video_url_na",
      input_params_obj: {
        programming_language: "programming_language_na",
        user_level: "advanced",
        difficulty_level: "medium",
        time_in_sec: 0,
        question_count: 0,
        custom_instructions: "based_on_prompts",
        consider_history: true,
      },
      assessment_obj: {
        topic: "topic_na",
        time_spent_seconds: 0,
        questions_attempted: 0,
        questions_total: 0,
        completion_status: "completed",
        ques_details: [
          {
            ques_id: "ques_id_na",
            ques_text: "ques_text_na",
            ans_id: "ans_id_na",
            ans_text: "ans_text_na",
            ans_code: "ans_code_na",
            test_cases_given: "test_cases_given_na",
            test_cases_passed: "test_cases_passed_na",
            hints_used: "hints_used_na",
            ai_chatbot_text: "ai_chatbot_text_na",
            time_spent_seconds: 0,
          },
        ],
      },
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: [],
        downloaded_blob_uri: [],
      },
      compute_time: 0,
      tokens_used: 0,
      cache_hit: false,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const baseStore = createSlice({
  name: "CodingCompanionLogging",
  initialState: initialState,
  reducers: {
    setAuditLogsHeartbeatStarted: (state, action) => ({
      ...state,
      auditLogsHeartbeatStarted: action.payload,
    }),
    setAuditLogsCompleteData: (state, action) => ({
      ...state,
      auditLogsCompleteData: action.payload,
    }),
    resetAuditLogState: () => initialState,
  },
})

export const { setAuditLogsHeartbeatStarted, setAuditLogsCompleteData, resetAuditLogState } = baseStore.actions

export default baseStore.reducer
